export default "__VITE_PUBLIC_ASSET__88107c93__"